import { UserMoreOperationList } from '../../config';
import styles from './index.less';
// import { RightOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import ModifyPassword from './ModifyPassword';
import { useState } from 'react';
import BindHouse from '@/pages/Mine/My/components/BindHouse';
import { Toast } from 'react-vant';
import { Arrow } from '@react-vant/icons';

const UserMoreOperation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [bindHouseVisible, setBindHouseVisible] = useState<boolean>(false);

  const { bindInformation } = useModel('useDefaultRoom', (model) => ({
    bindInformation: model.bindInformation,
  }));
  const { totalAmount } = useModel('useAccount', (model) => ({
    totalAmount: model.totalAmount,
  }));

  //判断用户是否绑定房屋
  const checkBindRoom = () => {
    return (
      bindInformation?.car === '0' &&
      bindInformation?.room === '0' &&
      bindInformation?.park === '0'
    );
  };

  const handlerJumpToLink = (redirectUrl: string, key: string) => {
    console.log('redirectUrl', redirectUrl);
    if (key === '2' && checkBindRoom()) {
      setBindHouseVisible(true);
      return;
    }
    if (key === '4' && checkBindRoom()) {
      Toast.fail('请您先绑定房屋！');
      return;
    }
    if (!redirectUrl) {
      switch (key) {
        case '3': // 修改密码 弹窗 非链接
          setIsOpen(true);
          break;
        default:
          break;
      }
      return;
    }
    history.push(redirectUrl);
  };

  return (
    <div className={styles.container}>
      {UserMoreOperationList.map((item, index) => (
        <div
          onClick={() => handlerJumpToLink(item.redirectUrl, item.key)}
          className={styles['operation-list']}
          key={item.key}
        >
          <div
            style={{
              marginBottom:
                index === UserMoreOperationList.length - 1 ? '0' : undefined,
            }}
          >
            <img src={item.img} alt={item.label} />
            <span>{item.label}</span>
          </div>
          <div
            style={{
              marginBottom:
                index === UserMoreOperationList.length - 1 ? '0' : undefined,
            }}
          >
            {checkBindRoom() && item.key === '2' && (
              <span className={styles['rightLabel']}>{item.rightLabel}</span>
            )}
            {totalAmount && item.key === '4' && (
              <span className={styles['rightLabel']}>{totalAmount}</span>
            )}
            <Arrow />
          </div>
        </div>
      ))}
      <ModifyPassword isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <BindHouse
        visible={bindHouseVisible}
        close={() => setBindHouseVisible(false)}
      />
    </div>
  );
};

export default UserMoreOperation;
